import {ICardLimits, TTypeAccountSubType} from "./limits.interface";
import {useGlobalContext} from "../../../../../../services/context.service";
import {Button, Grid, useMediaQuery} from "@mui/material";
import {getMedia} from "../../../../../../helpers/media";
import {useAppDispatch} from "../../../../../../hooks/redux";
import {Suspense, useEffect, useMemo, useState} from "react";
import {cardAPI} from "../../../../../../services/cardAPI.service";
import {checkPermission} from "../../../../../../helpers/permissions";
import ClientGroupTitle from "../../../../../Common/ClientGroupTitle";
import {fnLocalizeFilter} from "../../../../../../services/localize.service";
import CustomTable from "../../../../../UI/CustomTable";
import Loading from "../../../../../UI/Loading/Loading";
import {styled} from "@mui/material/styles";
import {IFilter, IOrderBy} from "../../../../../UI/CustomTable/interface/interface.custom";
import {COUNT_PER_ON_PAGE} from "../../../../../../helpers/api";
import ModalAddLimit from "./ModalAddLimit";
import {getColumnsLimits} from "./limits.columns";
import {useParams} from "react-router-dom";
import {holderAPI} from "../../../../../../services/holderAPI.service";
import {IAccounts} from "../../../../../../services/response.interface";

/* Кол-во строк в таблице счетов, на странице инфо клиента */
const countPerOnPage: number = +COUNT_PER_ON_PAGE;

const GridTitle = styled(Grid)(() => ({
    display: 'flex', alignItems: 'center', "&>.MuiGrid-root": {
        margin: 0
    }
}));

export default function CardLimits({card, cards, cardPurses, cardTypeLimits}: ICardLimits) {
    /* Получаем языковую локаль */
    const {locale} = useGlobalContext();
    /* Инициализация медиа  */
    const matches = useMediaQuery(getMedia());
    const dispatch = useAppDispatch();
    const [isOpenModal, setOpenModal] = useState({isShow: false, title: '', accountSubType: 0});
    const [account, setAccount] = useState<IAccounts>();

    /* Получаем адренсную строку */
    let {holderId = 0, accountId = 0} = useParams();

    /* Получаем список счетов выбранного клиента */
    const {data: dataAccounts = {accounts: []}} = holderAPI.useFetchAccountsClientQuery({
        locale, holderId: +holderId
    });

    useEffect(() => {
        const selectedAcc = dataAccounts.accounts.filter(a => a.id === +accountId)[0];
        setAccount(selectedAcc);
    }, [dataAccounts])

    /* Получаем список счетов выбранного клиента */
    const [getLimits, {
        data: dataLimits = {limits: []}, isLoading: isLoadingLimits, isSuccess: isSuccessLimits
    }] = cardAPI.useLazyFetchLimitsByCardQuery();

    useEffect(() => {
        card.cardId && getLimits({locale, cardId: card.cardId})
    }, [card, locale]);

    /* Заполняем табличные заголовки */
    const columns = useMemo(() => {
        return getColumnsLimits({
            locale, cards, limits: dataLimits.limits, cardId: card.id, dispatch
        });
    }, [cards, dispatch, card, locale, dataLimits]);

    /* Текущая страница счетов */
    const [pageNum, setPage] = useState<number>(0);
    const [orderBy, setOrderBy] = useState<IOrderBy>({field: "", order: "asc"});
    const handleChangePage = ({page, orderBy}: IFilter) => {
        //setRefresh( true );
        setOrderBy(orderBy);
        setPage(page - 1);
    };

    /* Фильтр по столбцам таблицы  */
    const rows = useMemo(() => {
        /* Применение фильтра */
        let filteredArr = dataLimits.limits;
        let count = filteredArr.length;

        /* Обрезаем массив до необходимых размеров отображения на странице */
        const startRow = pageNum === 0 ? 0 : (pageNum * countPerOnPage);
        const stopRow = (pageNum + 1) * countPerOnPage;

        /* Обрезаем по строкам на странице после фильтра */
        filteredArr = filteredArr.slice(startRow, stopRow);

        return {arr: filteredArr, count};

    }, [pageNum, orderBy, dataLimits]);

    /* Получаем подтип аккаунта */
    const accountSubType = useMemo(() => {
        return !!account ? account.accountSubType : 0
    }, [account]);


    const renderButtonsAddLimits = useMemo(() => {
        return checkPermission({permissionName: 'Limits'}) > 1 && <>
            {[0, 101].indexOf(accountSubType) !== -1 && <Button
                color={'secondary'}
                variant={'contained'}
                sx={{margin: '1rem'}}
                onClick={() => setOpenModal({
                    isShow: true,
                    title: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleMoneySchema'),
                    accountSubType: 101
                })}
            >
                {fnLocalizeFilter(locale, '_lang.module.cards.limits.titleMoneySchema')}
            </Button>}

            {[0, 102].indexOf(accountSubType) !== -1 && <Button
                color={'secondary'}
                variant={'contained'}
                sx={{margin: '1rem'}}
                onClick={() => setOpenModal({
                    isShow: true,
                    title: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleQtySchema'),
                    accountSubType: 102
                })}
            >
                {fnLocalizeFilter(locale, '_lang.module.cards.limits.titleQtySchema')}
            </Button>}

        </>
    }, [checkPermission, accountSubType, locale]);

    return <>
        <Grid item>
            <GridTitle item xs={12} sx={{margin: checkPermission({permissionName: 'Limits'}) > 1 ? 'initial' : '1rem'}}>
                <ClientGroupTitle isLoading={isLoadingLimits}
                                  title={fnLocalizeFilter(locale, '_lang.module.dataGroup.addLimits')} mt={0}
                />
                {renderButtonsAddLimits}
            </GridTitle>

            <CustomTable
                rows={rows.arr}
                columns={columns}
                isLoading={isLoadingLimits}
                count={rows.count}
                labelEmptyRows={fnLocalizeFilter(locale, '_lang.module.common.table.emptyRows')}
                rowsPerPageOptions={[countPerOnPage]}
                fnRefreshData={handleChangePage}
                accountId={card && card.id}
            />

        </Grid>
        {isOpenModal && <Suspense fallback={<Loading type={'fullScreen'}/>}>
            <ModalAddLimit title={isOpenModal.title} isShow={isOpenModal.isShow}
                           handleClose={() => setOpenModal({isShow: false, title: '', accountSubType : 0})} cardId={card && card.id}
                           accountSubType={isOpenModal.accountSubType as TTypeAccountSubType}/>
        </Suspense>}
    </>
}
